import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { InvestmentFocusLib } from "../../lib/data";
import useIsIPhone from "../../hooks/useIsIphone";

// assets
import bgImg from "../../assets/images/1920x1080-GRADIENT-BG.jpg";

const InvestmentFocus = () => {
  const isIphone = useIsIPhone();
  const slider = React.useRef(null);

  // react slider settings
  const settings = {
    dots: true,
    className: "center",
    centerMode: true,
    infinite: true,
    // centerPadding: "60px",
    speed: 500,
    slidesToShow: 1,
    // slidesToScroll: 1,
    arrows: false,
  };

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return (
    <section
      id="investment-focus"
      className="investment-focus bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="px-0 py-[50px] sm:px-[30px] sm:py-[50px] md:p-20">
        <div className="main-margin">
          <div className="px-[30px] md:p-0">
            <h1 className="sub-header text-white mb-10">Investment Focus</h1>
            <p className="mb-12 text-white">
              Digital infrastructure carries the digital traffic of our everyday
              communications. It supports the devices and applications we use to
              stay connected to essential information, people, communities and
              businesses. With an investment focus on data centers, cell towers,
              fiber networks, and other essential digital infrastructure assets,
              DIR offers access to a dynamic real estate sector at the heart of
              connectivity and data<sup>1</sup>.
            </p>
          </div>
          {screenSize.dynamicWidth > 700 || isIphone ? (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-5 items-stretch">
              {InvestmentFocusLib.map((a, i) => {
                return (
                  <div className="overflow-hidden flex flex-col">
                    <div>
                      <img
                        src={a.image}
                        alt={a.alt}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="bg-white p-7 flex flex-col flex-grow">
                      <h4 className="font-semibold text-lg mb-3">{a.title}</h4>
                      <p className="flex-grow mb-8">{a.info}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <Slider ref={slider} {...settings}>
                {InvestmentFocusLib.map((a, i) => {
                  return (
                    <div className="overflow-hidden flex flex-col p-3">
                      <div>
                        <img
                          src={a.image}
                          alt=""
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="bg-white p-7 flex flex-col flex-grow h-72">
                        <h4 className="font-semibold text-lg mb-3">
                          {a.title}
                        </h4>
                        <p className="flex-grow mb-8">{a.info}</p>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default InvestmentFocus;
